import React, { useState } from "react";
import { TextField, Button, CircularProgress, Input } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { setSuccess } from "../../../../Redux/AlertReducer";
import { useDispatch } from "react-redux";
import { Helper } from "../../../../tools/Helper";
import { api_Routes } from "../../../../tools/api_Routes";
import { errorToaster } from "../../../../helper/toasterConfiguration";

export const FormEditTicket = ({ data, setData }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
  const [file, setFile] = useState(null);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleDownload = async (report) => {
    try {
      const link = document.createElement("a");
      link.href = report;
      link.setAttribute("download", "image.jpg");
      link.setAttribute("target", "_blank");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      errorToaster(error || "Failed to download report");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoadingSubmit(true);

    const formDataToSend = new FormData();

    for (let key in data) {
      if (key === "report_url") {
        if (file) {
          formDataToSend.append("report", file);
        }
      } else if (data[key] !== null) {
        formDataToSend.append(key, data[key]);
      }
    }

    try {
      const { result, response, message } = await Helper.Post({
        url: api_Routes.TicketsAdvertising.Edit + id,
        data: formDataToSend,
        isFormData: true,
      });

      if (response) {
        dispatch(setSuccess(true));
        navigate("/Ads-Ticket");
      }
    } catch (error) {
      console.error("An error occurred during form submission:", error);
    }
    setIsLoadingSubmit(false);
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="grid grid-cols-1 items-center gap-4">
        <TextField
          fullWidth
          margin="normal"
          label="Subject"
          name="subject"
          required
          autoComplete="off"
          value={data?.subject}
          onChange={handleInputChange}
          variant="outlined"
        />
      </div>
      <div className="grid grid-cols-1 items-center gap-4">
        <TextField
          fullWidth
          margin="normal"
          type="number"
          label="Count ticket send"
          name="count_ticket_send"
          required
          autoComplete="off"
          value={data.count_ticket_send}
          onChange={handleInputChange}
          variant="outlined"
        />
      </div>
      <div className="flex gap-4 flex-col md:flex-row">
        {data?.report_url && (
          <Button
            onClick={() => {
              handleDownload(data?.report_url);
            }}
          >
            Download Your last report
          </Button>
        )}
        {data?.status === "complete" && (
          <Input
            type="file"
            className="mt-4 mb-6 w-full md:w-[calc(100%-260px)]"
            onChange={handleFileChange}
          />
        )}
      </div>
      <Button
        type="submit"
        fullWidth
        variant="contained"
        disabled={isLoadingSubmit}
        color="primary"
        sx={{
          display: isLoadingSubmit ? "flex" : "block",
          marginTop: 2,
          width: "20%",
          marginX: "auto",
          fontWeight: "bold",
          justifyContent: "center",
        }}
      >
        {isLoadingSubmit ? (
          <CircularProgress size={24} color="primary" />
        ) : (
          "Submit"
        )}
      </Button>
    </form>
  );
};
